<template>
  <div class="container pb-14 lg:pb-24">
    <Heading
      v-if="data.title"
      :semantic="isSemantic"
      :level="level"
      class="mb-5 text-2xl font-bold lg:text-3xl"
      >{{ data.title }}</Heading
    >
    <ArticleFilter class="mb-6" :categories="data.categories" />
    <ArticleList
      class="pt-2 lg:pt-8"
      :data="store.allArticles"
      :is-loading="store.isLoading"
      :load-more="store.loadMore"
      :load-more-label="data.linkMore"
      :is-empty="store.isEmpty"
    />
  </div>
</template>

<script setup lang="ts">
import { useBlogStore } from '~/stores/BlogStore'
import type { SectionArticleListRecord } from '~/types/generated'

const props = defineProps({
  data: {
    type: Object as PropType<SectionArticleListRecord>,
    default: () => {}
  },
  index: {
    type: Number,
    required: true
  }
})

const { level, isSemantic } = useSectionRules(props.index, !!props.data.title)

const route = useRoute()
const store = useBlogStore()
const { locale } = useI18n()

watch(
  () => route.query,
  () => {
    loadData()
  }
)

function loadData() {
  store.setLoading(true)

  if (route.query.category) {
    if (route.query.category !== store.allFilters) {
      store.resetArticles()
    }

    // Get filterID
    const { id } = store.getCategoryByName(route.query.category)
    store.pushFilters(route.query.category)

    // Filtered by Category
    store.fetchArticles(locale.value, id)
  } else {
    // Unfiltered / All Articles
    store.pushFilters('')
    store.resetArticles()
    store.fetchArticles(locale.value)
  }
}

onMounted(() => {
  store.setItemsPerPage(props.data.itemsPerPage)

  useTimeoutFn(() => {
    loadData()
  }, 10)
})
</script>
